export const bbaEntityNames = [
  'Service',
  'Campaign',
  'ClientPartner',
  'Proposal',
  'Workflow',
  'BrandAsset',
  'InstitutionalChannel',
  'Deliverable',
];

export const bbaReadOnlyNotice = 'BBA MVP is mock-driven and read-only. Billing, execution, and treasury routing are disabled.';
